import { Flex, FlexProps, Text } from '@modusign/design-system';

interface LabeledFileHashProps extends FlexProps<'div'> {
  label: string;
  hash: string;
}

export default function LabeledFileHash({ label, hash, ...flexProps }: LabeledFileHashProps) {
  return (
    <Flex {...flexProps} flexDirection="column">
      <Text
        backgroundColor="statusBackgroundNeutralBase"
        color="textNeutralLight"
        fontSize="xs"
        fontWeight="medium"
        px={2}
        sx={{
          alignSelf: 'flex-start',
          borderRadius: 3,
        }}
      >
        {label}
      </Text>
      <Text fontSize="sm" fontWeight="regular" mt={1}>
        {hash}
      </Text>
    </Flex>
  );
}
